<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">ประวัติการใช้งาน</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        ติดตามว่าใครสร้าง / แก้ไข / ลบข้อมูลอะไรในระบบ (อ่านอย่างเดียว)
      </p>
    </div>
    <div class="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center self-start">
      <div
        class="flex items-center gap-2 px-3 py-2 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 transition-all shadow-sm h-[46px]">
        <span class="material-icons text-slate-400 text-xl">calendar_today</span>
        <div class="relative w-[130px] h-full flex items-center">
          <div
            class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
            <span>{{ startDate() | date:'dd/MM/yyyy' }}</span>
            <span class="material-icons text-slate-400 text-lg">expand_more</span>
          </div>
          <input #startDatePicker type="date" [ngModel]="startDate()"
            (ngModelChange)="startDate.set($event); onDateChange()" [max]="endDate()"
            (click)="startDatePicker.showPicker()"
            class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]" />
        </div>
        <span class="text-slate-300 dark:text-slate-600">-</span>
        <div class="relative w-[130px] h-full flex items-center">
          <div
            class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
            <span>{{ endDate() | date:'dd/MM/yyyy' }}</span>
            <span class="material-icons text-slate-400 text-lg">expand_more</span>
          </div>
          <input #endDatePicker type="date" [ngModel]="endDate()"
            (ngModelChange)="endDate.set($event); onDateChange()" [min]="startDate()"
            (click)="endDatePicker.showPicker()"
            class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]" />
        </div>
      </div>
      <span class="text-xs text-slate-400 whitespace-nowrap">
        ดึงข้อมูลล่าสุด:
        <strong class="text-slate-600 dark:text-slate-300">
          {{ lastFetchedAt() ? (lastFetchedAt() | date:'HH:mm:ss') : 'ยังไม่ได้ดึงข้อมูล' }}
        </strong>
      </span>
      <button (click)="onRefresh()" title="ดึงข้อมูล"
        class="px-4 py-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 hover:shadow-md transition-all flex items-center gap-2 cursor-pointer">
        <span class="material-icons">refresh</span>
        <span class="font-bold">ดึงข้อมูล</span>
      </button>
    </div>
  </div>

  <div
    class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700">
      <div class="flex flex-col xl:flex-row xl:items-center justify-between gap-4">
        <div>
          <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500">history</span>รายการ Activity Log
          </h3>
        </div>
        <div class="flex flex-col lg:flex-row gap-3 w-full xl:max-w-3xl">
          <select [ngModel]="actionFilter()" (ngModelChange)="actionFilter.set($event); onFilterChange()"
            class="h-[46px] rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 px-3 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none">
            <option *ngFor="let opt of actionOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
          <select [ngModel]="entityTypeFilter()" (ngModelChange)="entityTypeFilter.set($event); onFilterChange()"
            class="h-[46px] rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 px-3 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none">
            <option *ngFor="let opt of entityTypeOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
          <div class="relative flex-1">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
            <input type="text" [ngModel]="searchText()" (ngModelChange)="searchText.set($event); onSearchChange()"
              placeholder="ค้นหาผู้ใช้, สรุป, entity..."
              class="w-full pl-10 pr-4 py-2.5 h-[46px] bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none" />
          </div>
        </div>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
      <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading()">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 border-b border-slate-100 dark:border-slate-700">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th class="p-4">เวลา</th>
            <th class="p-4">ผู้ใช้</th>
            <th class="p-4">การกระทำ</th>
            <th class="p-4">ประเภท</th>
            <th class="p-4">Entity ID</th>
            <th class="p-4">สรุป</th>
            <th class="p-4 text-center w-[90px]">ดู</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngFor="let item of items(); trackBy: trackById"
            class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40 transition-all">
            <td class="p-4 text-xs text-slate-500 whitespace-nowrap">
              {{ item.createDate ? (item.createDate | date:'dd/MM/yyyy HH:mm:ss') : '—' }}
            </td>
            <td class="p-4">
              <div class="font-bold text-slate-700 dark:text-slate-200">{{ item.actorUsername || '—' }}</div>
              <div class="text-xs text-slate-400">#{{ item.actorUserId }}</div>
            </td>
            <td class="p-4">
              <span class="px-2.5 py-1 rounded-full text-xs font-bold"
                [ngClass]="{
                  'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400': item.action === 'create',
                  'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400': item.action === 'update',
                  'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400': item.action === 'delete'
                }">
                {{ actionLabel(item.action) }}
              </span>
            </td>
            <td class="p-4 text-xs font-bold text-slate-600 dark:text-slate-300">{{ entityLabel(item.entityType) }}</td>
            <td class="p-4 font-mono text-xs text-slate-500">{{ item.entityId }}</td>
            <td class="p-4 text-slate-600 dark:text-slate-300">{{ item.summaryTh || '—' }}</td>
            <td class="p-4 text-center">
              <button (click)="openDetail(item)" title="ดูรายละเอียด"
                class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 text-slate-400 hover:border-amber-400 hover:text-amber-500 transition-all cursor-pointer">
                <span class="material-icons text-base">visibility</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="items().length === 0 && !isLoading()">
            <td colspan="7" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2 block">inbox</span>
              ไม่พบประวัติในเงื่อนไขที่เลือก
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="p-4 border-t border-slate-100 dark:border-slate-700 flex flex-col md:flex-row md:items-center justify-between gap-3">
      <div class="text-xs text-slate-400 font-medium">
        แสดง {{ startItemIndex }}-{{ endItemIndex }} จาก {{ totalItems() }} รายการ
      </div>
      <div class="flex items-center gap-2">
        <select class="h-9 rounded-lg border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 px-2 text-xs"
          [ngModel]="pageSize()" (change)="onPageSizeChange($event)">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
        </select>
        <button (click)="setPage(currentPage() - 1)" [disabled]="currentPage() <= 1"
          class="w-9 h-9 rounded-lg border border-slate-100 dark:border-slate-700 disabled:opacity-40 cursor-pointer">
          <span class="material-icons text-base">chevron_left</span>
        </button>
        <button *ngFor="let p of pagesArray" (click)="setPage(p)"
          class="w-9 h-9 rounded-lg text-xs font-bold cursor-pointer"
          [ngClass]="p === currentPage()
            ? 'bg-amber-400 text-white'
            : 'border border-slate-100 dark:border-slate-700 text-slate-500'">
          {{ p }}
        </button>
        <button (click)="setPage(currentPage() + 1)" [disabled]="currentPage() >= totalPages()"
          class="w-9 h-9 rounded-lg border border-slate-100 dark:border-slate-700 disabled:opacity-40 cursor-pointer">
          <span class="material-icons text-base">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Detail modal -->
<div *ngIf="isModalOpen()"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
  <div
    class="relative w-full max-w-2xl bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-700/50 max-h-[90vh] overflow-hidden flex flex-col animate-fade-in-up">
    <div class="p-6 border-b border-slate-100 dark:border-slate-700 flex items-center justify-between">
      <h3 class="text-lg font-black text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">info</span>
        รายละเอียดการกระทำ
      </h3>
      <button (click)="closeModal()"
        class="w-9 h-9 rounded-xl border border-slate-100 dark:border-slate-700 text-slate-400 hover:text-rose-500 cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>
    <div class="p-6 overflow-y-auto custom-scrollbar relative min-h-[200px]">
      <app-pss-loading *ngIf="isDetailLoading()"></app-pss-loading>
      <ng-container *ngIf="selectedDetail() as detail">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
          <div>
            <div class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">ผู้ใช้</div>
            <div class="font-bold text-slate-700 dark:text-slate-200">{{ detail.actorUsername || '—' }} (#{{ detail.actorUserId }})</div>
          </div>
          <div>
            <div class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">เวลา</div>
            <div class="font-bold text-slate-700 dark:text-slate-200">
              {{ detail.createDate ? (detail.createDate | date:'dd/MM/yyyy HH:mm:ss') : '—' }}
            </div>
          </div>
          <div>
            <div class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">การกระทำ</div>
            <div class="font-bold">{{ actionLabel(detail.action) }}</div>
          </div>
          <div>
            <div class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">ประเภท / ID</div>
            <div class="font-bold">{{ entityLabel(detail.entityType) }} #{{ detail.entityId }}</div>
          </div>
          <div class="sm:col-span-2">
            <div class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">สรุป</div>
            <div class="font-medium text-slate-700 dark:text-slate-200">{{ detail.summaryTh || '—' }}</div>
          </div>
        </div>

        <div class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3">การเปลี่ยนแปลง (Before → After)</div>
        <div *ngIf="detail.changes.length === 0" class="text-slate-400 text-sm py-6 text-center">ไม่มีรายละเอียด field</div>
        <div *ngIf="detail.changes.length > 0" class="rounded-2xl border border-slate-100 dark:border-slate-700 overflow-hidden">
          <table class="w-full text-left">
            <thead class="bg-slate-50 dark:bg-slate-800 text-xs font-bold text-slate-400 uppercase">
              <tr>
                <th class="p-3">รายการ</th>
                <th class="p-3">ก่อน</th>
                <th class="p-3">หลัง</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
              <tr *ngFor="let c of detail.changes">
                <td class="p-3 text-xs font-bold text-slate-600 dark:text-slate-300">{{ fieldLabel(c.field) }}</td>
                <td class="p-3 text-rose-600 dark:text-rose-400 font-medium break-all">{{ valueLabel(c.before) }}</td>
                <td class="p-3 text-emerald-600 dark:text-emerald-400 font-medium break-all">{{ valueLabel(c.after) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>
